import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/constants";
import { Phone, Mail, MapPin, Facebook, Star } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-white/5 mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <img src="/logos/monogram.png" alt="Delux Limo Trans Group" className="w-12 h-12 object-contain"/>
            <div className="leading-tight">
              <div className="font-serif text-lg text-[#F5F2EB]">{BRAND.name}</div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-[#A1A1AA]">Est. {BRAND.est} · Premium Chauffeur &amp; Luxury Transportation</div>
            </div>
          </div>
          <p className="text-[#A1A1AA] text-sm leading-relaxed max-w-md">
            Chauffeured sedans, SUVs, extended SUVs and Sprinter vans serving the Midwest with quiet, dependable luxury — 24/7.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a
              data-testid="footer-facebook"
              href={BRAND.facebook}
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              title="Follow us on Facebook"
              className="w-9 h-9 border border-white/10 flex items-center justify-center text-[#A1A1AA] hover:text-[#D4AF37] hover:border-[#D4AF37] transition-colors"
            >
              <Facebook size={16}/>
            </a>
            <a
              data-testid="footer-google"
              href={BRAND.googleMaps}
              target="_blank"
              rel="noreferrer"
              aria-label="Google reviews"
              title="Find us on Google — 5.0 stars"
              className="h-9 px-3 border border-white/10 inline-flex items-center gap-2 text-[#A1A1AA] hover:text-[#D4AF37] hover:border-[#D4AF37] transition-colors text-xs"
            >
              <Star size={14} className="text-[#D4AF37]"/>5.0 on Google
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-5">Contact</div>
          <ul className="space-y-3 text-sm text-[#A1A1AA]">
            {BRAND.phones.map(p => (
              <li key={p}><a href={`tel:${p.replace(/[^0-9+]/g, "")}`} className="hover:text-[#D4AF37] inline-flex items-center gap-2"><Phone size={14}/>{p}</a></li>
            ))}
            <li><a href={`mailto:${BRAND.email}`} className="hover:text-[#D4AF37] inline-flex items-center gap-2"><Mail size={14}/>{BRAND.email}</a></li>
            <li className="inline-flex items-center gap-2"><MapPin size={14}/>{BRAND.area}</li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline mb-5">Quick Links</div>
          <ul className="grid grid-cols-2 gap-3 text-sm text-[#A1A1AA]">
            <li><Link to="/book" className="hover:text-[#D4AF37]">Book a Ride</Link></li>
            <li><Link to="/events" className="hover:text-[#D4AF37]">Weddings &amp; Events</Link></li>
            <li><Link to="/lookup" className="hover:text-[#D4AF37]">Find Reservation</Link></li>
            <li><Link to="/#fleet" className="hover:text-[#D4AF37]">Our Fleet</Link></li>
            <li><Link to="/#services" className="hover:text-[#D4AF37]">Services</Link></li>
            <li><Link to="/drive-with-us" className="hover:text-[#D4AF37]">Driver / Dispatch</Link></li>
            <li><a href={`tel:${BRAND.phones[0].replace(/[^0-9+]/g, "")}`} className="hover:text-[#D4AF37]">24/7 Concierge</a></li>
            <li><Link to="/privacy" className="hover:text-[#D4AF37]">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[#D4AF37]">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#52525B]">
          <span>© {new Date().getFullYear()} Delux Limo Trans Group · All rights reserved.</span>
          <span className="uppercase tracking-[0.28em]">Arrive with distinction</span>
        </div>
      </div>
    </footer>
  );
}
